import axios from 'axios';

const API_URL = `${process.env.REACT_APP_SERVER_URL}/app/releases`;

export interface AndroidRelease {
    id: number;
    version_name: string;
    version_code: number;
    apk_url: string;
    file_name: string;
    file_size: number;
    release_notes?: string | null;
    is_active: number;
    created_user_id?: number | null;
    created_time: string;
    updated_time: string;
}

export const AppReleaseService = {
    uploadAndroidRelease: async (formData: FormData) => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.post(`${API_URL}/android/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },

    // Public: mobile app checks for latest version without needing a token
    getLatestAndroidRelease: async (): Promise<AndroidRelease | null> => {
        try {
            const response = await axios.get(`${API_URL}/android/latest`);
            return response.data?.data ?? null;
        } catch (error: any) {
            if (error?.response?.status === 404) {
                return null;
            }
            throw error;
        }
    },

    getAndroidReleaseHistory: async (limit: number = 20): Promise<AndroidRelease[]> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/android/history`, {
            params: { limit },
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data?.data ?? [];
    },

    getAndroidReleaseById: async (id: number): Promise<AndroidRelease> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/android/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data?.data;
    },

    updateAndroidReleaseMeta: async (
        id: number,
        payload: Pick<AndroidRelease, 'version_name' | 'version_code'> & {
            release_notes?: string | null;
        }
    ) => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.put(`${API_URL}/android/${id}`, payload, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    activateAndroidRelease: async (id: number) => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.put(`${API_URL}/android/${id}/activate`, null, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },
};
